import { combineReducers } from 'redux'
import { reducer as FormReducer } from 'redux-form'
import { default as auth } from './Auth'

export default combineReducers({
    auth,
    form: FormReducer
});



// WEBPACK FOOTER //
// ./src/ducks/index.js